// Shared Google Maps loader config used across the entire app.
//
// `useJsApiLoader` from @react-google-maps/api enforces a single global
// configuration: every call must use the SAME id, SAME libraries, and SAME
// version, otherwise it throws "Loader must not be called again with different
// options". Therefore any component that mounts a Google Map must import these
// constants and pass them to its loader hook.
//
// Version is pinned to the `quarterly` channel because the unpinned `weekly`
// default landed at 3.65 which removed DrawingManager and several other
// long-standing APIs. `quarterly` follows Google's quarterly support window
// and is the most stable channel available without a hard-coded version
// number that would have to be bumped manually.

export const GOOGLE_MAPS_LOADER_ID = 'google-map-script';

export const GOOGLE_MAPS_VERSION = 'quarterly';

export const GOOGLE_MAPS_LIBRARIES: ('places' | 'geometry')[] = [];
